import axios from '@/services/axiosConfig'
const headerFormData = {
	headers: {
		'Content-Type': 'multipart/form-data',
	},
}

const endPoint = {
	lookupList: instId => `/institute/${instId}/inspect/list`,
	lookupDetail: (instId, id) => `/institute/${instId}/inspect?id=${id}`,
	createItem: instId => `/institute/${instId}/inspect/image`,
	editItem: instId => `/institute/${instId}/inspect/user`,
	registerItem: instId => `/institute/${instId}/inspect/inventory/register`,
	deleteItem: instId => `/institute/${instId}/inspect`,
}

const InventoryInspectAPI = {
	lookupList: (instId, paramObj) =>
		axios.get(endPoint.lookupList(instId), { params: paramObj }),
	lookupDetail: (instId, id) => axios.get(endPoint.lookupDetail(instId, id)),
	createItem: (instId, formData) =>
		axios.post(endPoint.createItem(instId), formData, headerFormData),
	editItem: (instId, formData) =>
		axios.put(endPoint.editItem(instId), formData, headerFormData),
	registerItem: (instId, data) =>
		axios.post(endPoint.registerItem(instId), data),
	deleteItem: (instId, paramObj) =>
		axios.delete(endPoint.deleteItem(instId), { params: paramObj }),
}

export default InventoryInspectAPI
